import { SvgIcon, SvgIconProps } from "@mui/material";

const TripsIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <g>
            <path d="M21.4444 11.4118L21.2667 11.4294L15.3333 12.6471L8.66667 11.4118L2.4 12.5294C2.16667 12.5706 2 12.6765 2 12.8118V21.7059C2 21.8706 2.24444 22 2.55556 22L2.73333 21.9824L8.66667 20.7647L15.3333 22L21.6 20.8824C21.8333 20.8412 22 20.7353 22 20.6V11.7059C22 11.5412 21.7556 11.4118 21.4444 11.4118ZM15.3333 20.8235L8.66667 19.5824V12.5882L15.3333 13.8294V20.8235Z" fill="currentColor" />
            <path d="M12.625 2C10.2063 2 8.25 3.84118 8.25 6.11765C8.25 9.20588 12.625 14.9412 12.625 14.9412C12.625 14.9412 17 9.20588 17 6.11765C17 3.84118 15.0437 2 12.625 2ZM12.625 7.58824C11.7625 7.58824 11.0625 6.92941 11.0625 6.11765C11.0625 5.30588 11.7625 4.64706 12.625 4.64706C13.4875 4.64706 14.1875 5.30588 14.1875 6.11765C14.1875 6.92941 13.4875 7.58824 12.625 7.58824Z" fill="currentColor" />
        </g>
    </SvgIcon>
);

export default TripsIcon;
